import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewSourceLink"] */ "/opt/build/repo/docs/src/components/Subtitle/ViewSourceLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/utils/direction-provider/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.22_@types+react@19.2.14_next@16.2.9_@babel+core@_854189f088002886d7a9a56cf478bb9f/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.22_@types+react@19.2.14_next@16.2.9_@babel+core@_854189f088002886d7a9a56cf478bb9f/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useCodeFallback"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.22_@types+react@19.2.14_next@16.2.9_@babel+core@_854189f088002886d7a9a56cf478bb9f/node_modules/@mui/internal-docs-infra/CodeHighlighter/useCodeFallback.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CoordinatedLazyClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.22_@types+react@19.2.14_next@16.2.9_@babel+core@_854189f088002886d7a9a56cf478bb9f/node_modules/@mui/internal-docs-infra/CoordinatedLazy/CoordinatedLazyClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.2.9_@babel+core@7.29.0_@playwright+test@1.59.1_babel-plugin-react-compiler@1.0._65553a6a31af182baee48d8e2deee842/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DirectionProvider"] */ "/opt/build/repo/packages/react/src/direction-provider/DirectionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useDirection"] */ "/opt/build/repo/packages/react/src/internals/direction-context/DirectionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderControl"] */ "/opt/build/repo/packages/react/src/slider/control/SliderControl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderIndicator"] */ "/opt/build/repo/packages/react/src/slider/indicator/SliderIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderLabel"] */ "/opt/build/repo/packages/react/src/slider/label/SliderLabel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderRoot"] */ "/opt/build/repo/packages/react/src/slider/root/SliderRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderThumb"] */ "/opt/build/repo/packages/react/src/slider/thumb/SliderThumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderTrack"] */ "/opt/build/repo/packages/react/src/slider/track/SliderTrack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderValue"] */ "/opt/build/repo/packages/react/src/slider/value/SliderValue.tsx");
